import EA from 'helpers/init';

export default EA.Methods.bannerSetup = ($this) => {
    // console.log('bannerSetup', $this);

    const $banner = $this;
    // const $bannerAd = $banner.querySelector('ins');
    const $bannerInterscroller = $banner.querySelector('.banner--interscroller');

    // Check if the interscroller exists
    if ($bannerInterscroller) {
        // Create a new observer for the interscroller
        const interscrollerObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                // Check if the top of the interscroller is in the viewport
                if (entry.isIntersecting) {
                    // If the top of the interscroller is in the viewport, add a class
                    $bannerInterscroller.classList.add('in-viewport');
                } else {
                    // If the top of the interscroller is not in the viewport, remove the class
                    $bannerInterscroller.classList.remove('in-viewport');
                }
            });
        }, {
            root: null,
            rootMargin: '50px',
            threshold: 0.3, // Adjust threshold as needed
        });
    
        // Start observing the interscroller
        interscrollerObserver.observe($banner);
    }
}
